import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { Heart } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export const FamiliesPage = () => {
  const [families, setFamilies] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    fetchFamilies();
  }, []);

  const fetchFamilies = async () => {
    try {
      const { data } = await axios.get(`${API_URL}/api/families`, { withCredentials: true });
      setFamilies(data);
    } catch (error) {
      console.error('Error fetching families:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="families-page" className="space-y-6">
      <div>
        <h1 className="text-4xl font-bold text-forest mb-2" style={{ fontFamily: 'Cormorant Garamond, serif' }}>
          Familles
        </h1>
        <p className="text-stone-600">Liste des unions et couples</p>
      </div>

      {loading ? (
        <div data-testid="families-loading" className="text-center py-12 text-stone-500">Chargement...</div>
      ) : (
        <div className="space-y-4">
          {families.map((family) => (
            <div
              key={family.handle}
              data-testid={`family-card-${family.handle}`}
              onClick={() => navigate(`/families/${family.handle}`)}
              className="bg-white border border-parchment-dark p-6 hover:-translate-y-1 transition-transform cursor-pointer"
            >
              <div className="flex items-center space-x-4">
                <Heart className="text-terracotta" size={24} />
                <div className="flex-1">
                  <div className="font-semibold text-lg text-forest" style={{ fontFamily: 'Cormorant Garamond, serif' }}>
                    {family.father_given_name || ''} {family.father_surname || ''}
                    {(family.father_given_name || family.mother_given_name) && ' & '}
                    {family.mother_given_name || ''} {family.mother_surname || ''}
                  </div>
                  {family.gramps_id && (
                    <p className="text-sm text-stone-500 mt-1">ID: {family.gramps_id}</p>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      {!loading && families.length === 0 && (
        <div data-testid="families-empty" className="text-center py-12 text-stone-500">
          Aucune famille trouvée
        </div>
      )}
    </div>
  );
};
